export const GPCConstant = {
    isErrorOccured: false,
    isLoading: false,
    isGoogleAnalyticsEnabled: false,
    errorState: { error: '', errorCode: 0 },
    contentData: {
        headerText: '',
        privacy: '',
        termsOfUse: '',
        pbeHeader: '',
        gpcHeader: '',
        uploadSuccessfulMessage: '',
        repairAssignmentSuccessfulMessage: '',
        postUploadRevisitMessage: '',
        redirectionButtonText: ''
    },
    styleData: {
        headerText: '',
        privacyPolicyUrl: '',
        termsOfUseUrl: '',
        uploadSuccessfulMessage: '',
        avatarUrl: '',
        headerColor: '',
        languageFontSize: 0,
        languageFontColor: '',
        languageGlobeColor: '',
        avatarColor: '',
        applicationBackgroundColor: '',
        disabledButtonBackgroundColor: '',
        disabledButtonTextColor: '',
        finishButtonColor: '',
        finishButtonTextColor: '',
        headerBackgroundColor: '',
        headerTextColor: '',
        languageDropdownTextColor: '',
        primaryButtonBackgroundColor: '',
        buttonBackgroundColor: '',
        primaryButtonTextColor: '',
        buttonTextColor: '',
        speechBoxBackgroundColor: '',
        thumpsUpGraphicBackgroundColor: '',
        thumbsUpColor: '',
        avatarImage: '',
        selectedButtonBackgroundColor: '',
        secondaryButtonBackgroundColor: '',
        secondaryButtonTextColor: ''
    }
};
export const RICHTEXT_DEFAULT_VALUE = '<p><br></p>';
export const PHOTO_CAPTURE_DEFAULT_ERRORCODE = 1;
export const PHOTO_CAPTURE_SOMETHING_WENT_WRONG_ERRORCODE = 195004;
export const PHOTO_CAPTURE_INVALID_VIN_ERRORCODE = 195005;
export const PHOTO_CAPTURE_VIN_DECODE_195000_ERRORCODE = 195000;
export const PHOTO_CAPTURE_VIN_DECODE_195001_ERRORCODE = 195001;
export const PHOTO_CAPTURE_VIN_DECODE_UNAVAILABLE_ERRORCODE = 195006;
export const PHOTO_CAPTURE_VIN_DECODE_NETWORK_ERRORCODE = 500;
export const PHOTO_CAPTURE_DEFAULT_ERRORMSG = 'Something went wrong. Please contact system administrator.';
//# sourceMappingURL=GPCConstants.js.map